import * as React from "react";
import { useDrop } from "react-dnd";

export const ItemTypes = {
  BOX: "box"
};

const style = {};

const Dropable = ({ name, projectId, priority, children, action, done }) => {

  const dropCalc = (name, projectId, priority, action, done) =>
  {
    const ret = { 
      name: name ? name : projectId ? projectId : null, 
      action: action ? action : null,
      done: done ? done : false,
    };
  

    return { ...ret, priority};
  }
  const [{ canDrop, isOver }, drop] = useDrop({
    accept: ItemTypes.BOX,
    drop: () => (dropCalc(name, projectId, priority, action, done)),
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  });
  const isActive = canDrop && isOver;
  let border = "unset";
  if (isActive) {
    border = "1px solid silver";
  } else if (canDrop) {
    border = "0px solid darkkhaki";
  }
  return (
    <div ref={drop} style={{ ...style, border }}>
      {children}
    </div>
  );
};

export default Dropable;
